// extracted by mini-css-extract-plugin
export default {"our-team":"OurTeam_our-team__KjDgp"};